import { Component } from '@angular/core';
import { ConsignmentTrackingComponent } from '@spartacus/order/components';

@Component({
  selector: 'app-custom-consignment-tracking',
  templateUrl: './custom-consignment-tracking.component.html',
  standalone: false
})
export class CustomConsignmentTrackingComponent extends ConsignmentTrackingComponent {

}
